<template>
  <div>
    <div class="header">
      <h1 class="page-title">账户安全</h1>
    </div>
    <el-card class="box-card">
      <div class="cont-box">
        <div class="cont-left">
          <div class="line"></div>
          <img :src="avatar" />
          <span>{{username}}</span>
          <span class="grade">普通VIP</span>
          <div class="userimg">
            <img src="../../../assets/user/shenfen.png" class="one" />
            <img src="../../../assets/user/pwd.png" class="one" />
            <img src="../../../assets/user/zhifu.png" class="one" />
            <img src="../../../assets/user/phone.png" class="one" />
            <img src="../../../assets/user/qq.png" class="one" />
            <img src="../../../assets/user/wx.png" class="one" />
          </div>
        </div>
        <div class="cont-right">
          <div class="top">
            <span>您的账户等级:</span>
            <div class="pro-box">
              <el-progress color="#faad14" :percentage="100" :format="format" :stroke-width="10"></el-progress>
            </div>
            <span class="jianyi">建议你启动全部安全设置，以保障账户及资金安全</span>
          </div>
          <ul>
            <li>
              <img src="../../../assets/user/authentication.png" alt />
              <div class="li-text">
                <span>身份认证</span>
                <span class="li-text2">用于提升账号的安全和信任级别，认证后的有卖家记录的账号不能修改认证信息</span>
              </div>
              <img src="../../../assets/user/no.png" class="li-img" />
              <span class="li-txt" @click="showRenZheng">认证</span>
            </li>
            <li>
              <img src="../../../assets/user/bigpwd.png" alt />
              <div class="li-text">
                <span>登陆密码</span>
                <span class="li-text2">安全性高的密码可以使账号更安全。建议您定期更换密码，且设置一个包含数字和字母，并长度超过6位以上的密码</span>
              </div>
              <img src="../../../assets/user/old.png" class="li-img" />
              <span class="xiu" @click="editShowDialog()">修改</span>
            </li>
            <li>
              <img src="../../../assets/user/zhifupwd.png" alt />
              <div class="li-text">
                <span>支付密码</span>
                <span class="li-text2">申请体现或余额支付时，均须支付密码进行身份验证</span>
              </div>
              <img src="../../../assets/user/no.png" class="li-img" />
              <span class="li-txt" @click="editShowpwd()">设置</span>
            </li>
            <li>
              <img src="../../../assets/user/bigphone.png" alt />
              <div class="li-text">
                <span>绑定手机</span>
                <span class="li-text2">绑定手机后，您即可享受丰富的手机服务，如手机找回密码等</span>
              </div>
              <img src="../../../assets/user/old.png" class="li-img" />
              <span class="xiu" @click="editShowphone()">修改</span>
            </li>
            <li>
              <img src="../../../assets/user/bigqq.png" alt />
              <div class="li-text">
                <span>绑定QQ</span>
                <span class="li-text2">绑定QQ后，可以更加方便和您沟通稿件的问题</span>
              </div>
              <img src="../../../assets/user/no.png" class="li-img" />
              <span class="bang" @click="showQq">绑定</span>
            </li>
            <li>
              <img src="../../../assets/user/bigwx.png" alt />
              <div class="li-text">
                <span>绑定微信</span>
                <span class="li-text2">绑定微信后，可以更加方便的和您沟通稿件的问题</span>
              </div>
              <img src="../../../assets/user/no.png" class="li-img" />
              <span class="bang" @click="showwx">绑定</span>
            </li>
          </ul>
        </div>
      </div>
    </el-card>
    <!-- 身份认证 -->
    <el-dialog :visible.sync="dialogVisible7" class="dia-title" title="身份认证" width="45%">
      <div style="paddig:0 10px;">
        <div class="dialog-geren">
          <div class="dialog-one">
            <span class="dialog-one1"></span>
            <span>个人认证</span>
          </div>
          <div class="dialog-one">
            <span class="dialog-one1"></span>
            <span>企业认证</span>
          </div>
        </div>
        <el-form style="margin-top:20px;display: flex;flex-wrap: wrap;" class="demo-ruleForm">
          <el-form-item style="width:50%;">
            <div>真实姓名</div>
            <el-input placeholder="请输入真实姓名" style="width:90%;"></el-input>
          </el-form-item>
          <el-form-item style="width:50%;">
            <div>身份证号</div>
            <el-input placeholder="请输入身份证号" style="width:90%;"></el-input>
          </el-form-item>
          <div class="flie-img">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="o1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="o2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="o3"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
          <el-form-item style="width:50%;">
            <div>手机号码</div>
            <el-input placeholder="请输入手机号" style="width:90%;"></el-input>
          </el-form-item>
          <el-form-item style="width:50%;">
            <div>验证码</div>
            <el-input placeholder="请输入验证码" style="width:50%;"></el-input>
            <el-button
              style="margin-left:10px; background:#f2fbf7; color:#1ab36a; border:1px solid #97ddbc;"
            >获取验证码</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer gai1">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;width:100px;"
        >认证</el-button>
        <el-button @click="dialogVisible1 = false" style="width:100px;">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog :visible.sync="dialogVisible1" class="dia-title" title="修改密码" width="25%">
      <el-form style="margin-top:10px" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码">
          <el-input placeholder="请输入旧密码" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请设置新密码" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input placeholder="请再输入一次密码" style="width:94%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;"
        >保存</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 设置支付密码 -->
    <el-dialog :visible.sync="dialogVisible2" class="dia-title" title="设置支付密码" width="25%">
      <el-form style="margin-top:10px" label-width="80px" class="demo-ruleForm">
        <el-form-item label="手机号码">
          <el-input placeholder="请输入手机号" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input placeholder="请输入验证码" style="width:60%;"></el-input>
          <el-button
            style="margin-left:10px; background:#f2fbf7; color:#1ab36a; border:1px solid #97ddbc;"
          >获取验证码</el-button>
        </el-form-item>
        <el-form-item label="支付密码">
          <el-input placeholder="请设置支付密码" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input placeholder="请再次确认支付密码" style="width:94%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;"
        >保存</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 绑定手机号 -->
    <el-dialog :visible.sync="dialogVisible4" class="dia-title" title="绑定手机号" width="25%">
      <el-form style="margin-top:10px" label-width="80px" class="demo-ruleForm">
        <el-form-item label="手机号码">
          <el-input placeholder="请输入手机号" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="校验码">
          <el-input placeholder="请输入校验码" style="width:60%;"></el-input>
          <el-button
            style="margin-left:10px; background:#f2fbf7; color:#1ab36a; border:1px solid #97ddbc;"
          >获取校验码</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;"
        >绑定</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改手机号 -->
    <el-dialog :visible.sync="dialogVisible3" class="dia-title" title="修改手机号" width="30%">
      <el-steps :active="1" align-center>
        <el-step title="输入新手机号"></el-step>
        <el-step title="验证身份"></el-step>
        <el-step title="修改成功"></el-step>
      </el-steps>
      <div class="dia-txt">一个手机号最多还能被一个账户用作登录名;绑定新的手机号码时,需要将当前的绑定关系解除之后能绑定新的手机号;</div>
      <el-form style="margin-top:10px;margin-left:80px;" label-width="90px" class="demo-ruleForm">
        <el-form-item label="新手机号码">
          <el-input placeholder="请输入新手机号" style="width:73%;"></el-input>
        </el-form-item>
        <el-form-item label="校验码">
          <el-input placeholder="请输入校验码" style="width:40%;"></el-input>
          <el-button
            style="margin-left:10px; background:#f2fbf7; color:#1ab36a; border:1px solid #97ddbc;"
          >获取校验码</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer gai">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none; width: 100px;"
        >确定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定QQ -->
    <el-dialog :visible.sync="dialogVisible5" class="dia-title" title="绑定QQ号" width="25%">
      <el-form style="margin-top:10px" label-width="80px" class="demo-ruleForm">
        <el-form-item label="QQ账号">
          <el-input placeholder="请输入QQ号" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input placeholder="请输入QQ密码" style="width:94%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;"
        >绑定</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 绑定微信 -->
    <el-dialog :visible.sync="dialogVisible6" class="dia-title" title="绑定手机号" width="25%">
      <el-form style="margin-top:10px" label-width="80px" class="demo-ruleForm">
        <el-form-item label="手机号码">
          <el-input placeholder="请输入手机号" style="width:94%;"></el-input>
        </el-form-item>
        <el-form-item label="校验码">
          <el-input placeholder="请输入校验码" style="width:60%;"></el-input>
          <el-button
            style="margin-left:10px; background:#f2fbf7; color:#1ab36a; border:1px solid #97ddbc;"
          >获取校验码</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm()"
          style="background:#a77c5a; color:#e1f5ec; border:none;"
        >绑定</el-button>
        <el-button @click="dialogVisible1 = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      avatar: '',
      username: '',
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    format(percentage) {
      return percentage === 100 ? '高' : `低`
    },
    //身份认证
    showRenZheng() {
      this.dialogVisible7 = true
      $('.el-upload--picture-card').css(
        'background',
        'url(../../../assets/user/front.png)'
      )
    },
    //修改密码
    editShowDialog(data) {
      this.dialogVisible1 = true
    },
    //设置支付密码
    editShowpwd() {
      this.dialogVisible2 = true
    },
    //绑定手机号
    editShowphone() {
      this.dialogVisible3 = true
    },
    //绑定qq
    showQq() {
      this.dialogVisible5 = true
    },
    //绑定微信
    showwx() {
      this.dialogVisible6 = true
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  },
  created() { 
    if(!window.localStorage.getItem('token')){
      this.$router.replace('/login')
      return
    }
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.avatar = JSON.parse(u).avatar
      this.username = JSON.parse(u).username
      this.getYue()
    }
  }
}
</script>

<style lang="less" scoped>
// 上传身份证
.flie-img {
  width: 100%;
  display: flex;
}
.gai {
  display: flex;
  justify-content: space-evenly;
}
.gai1 {
  display: flex;
  justify-content: center;
}
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.cont-box {
  display: flex;

  .cont-left {
    position: relative;
    width: 161px;
    height: 675px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .line {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 92%;
      border-right: 2px solid #eee;
    }
    img {
      width: 80px;
      height: 80px;
      margin-top: 22px;
    }
    span {
      display: block;
      font-size: 16px;
      font-weight: 400;
      line-height: 27px;
      margin-top: 24px;
      color: rgba(89, 89, 89, 1);
      opacity: 1;
    }
    .grade {
      font-size: 12px;
      margin-top: 0px;
    }
    .userimg {
      display: flex;
      width: 140px;
      height: 50px;
      flex-wrap: wrap;
      color: rgba(24, 144, 255, 1);
      margin-left: 20px;
      .one {
        width: 25px;
        height: 25px;
        margin-right: 6px;
        margin-top: 10px;
      }
    }
  }
  .cont-right {
    width: 100%;
    padding-left: 30px;
    box-sizing: border-box;
    .top {
      width: 98%;
      height: 40px;
      border: 1px solid #fef4e1;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      padding-left: 16px;
      box-sizing: border-box;
      background: #fffbf3;
      span {
        display: block;
        width: 12%;
        color: #fbc250;
      }
      .pro-box {
        width: 30%;
      }
      .jianyi {
        width: 50%;
        font-size: 14px;
        color: #abaaa8;
      }
    }
    ul {
      margin-top: 30px;
      li {
        display: flex;
        align-items: center;
        width: 100%;
        height: 80px;
        padding-left: 16px;
        box-sizing: border-box;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-bottom: 20px;
        position: relative;
        .li-text {
          font-size: 16px;
          line-height: 26px;
          margin-left: 10px;
          font-weight: 550;
          span {
            display: block;
          }
          .li-text2 {
            font-weight: 400;
            color: #abaaa8;
            font-size: 14px;
          }
        }
        .li-img {
          position: absolute;
          top: 20px;
          right: 300px;
        }
        .li-txt,
        .xiu,
        .bang {
          position: absolute;
          top: 30px;
          right: 50px;
          font-size: 16px;
          display: block;
          color: #abaaa8;
          font-weight: 400;
        }
        .li-txt:hover {
          color: #1890ff;
          cursor: pointer;
        }
        .xiu:hover {
          color: #faad14;
          cursor: pointer;
        }
        .bang:hover {
          color: #a77c5a;
          cursor: pointer;
        }
      }
      li:hover {
        box-shadow: 0px 0px 4px #1890ff;
      }
    }
  }
}
.dia-txt {
  width: 470px;
  height: 50px;
  font-size: 14px;
  line-height: 25px;
  margin: 10px 30px;
  color: #abaaa8;
  background: #fffcf5;
  border: 1px solid #fddd9b;
  padding: 0 10px;
  box-sizing: border-box;
}
.dialog-geren {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  .dialog-one {
    width: 100px;
    height: 35px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #abaaa8;
    font-weight: 550;
    margin-right: 20px;
    span {
      display: flex;
    }
    .dialog-one1 {
      width: 14px;
      height: 14px;
      background: url(../../../assets/user/shen.png) no-repeat;
      background-size: 100%;
    }
  }
  .dialog-one:hover {
    color: #a77c5a;
    box-shadow: 0px 0px 4px rgba(19, 231, 132, 0.08);
    cursor: pointer;
  }
  .dialog-one:hover .dialog-one1 {
    background: url(../../../assets/user/selshen.png) no-repeat;
  }
}
</style>